<template>
  <div class="stats-empty-state">
    <div class="stats-empty-state__icon">
      <i :class="icon" />
    </div>
    <p class="stats-empty-state__message">
      {{ message ?? t('stats.noData') }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'StatsEmptyState',
  props: {
    icon: {
      type: String,
      default: 'fa-thin fa-chart-line',
    },
    message: {
      type: String,
      default: null,
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
.stats-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 8rem;
  padding: 1.5rem 1rem;
  color: #9ca3af;
  text-align: center;
  gap: 0.75rem;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    background: #f3f4f6;
    color: #9ca3af;
    font-size: 1.5rem;
  }

  &__message {
    margin: 0;
    font-size: 0.95rem;
    line-height: 1.4;
  }
}
</style>
